import { Directive, EventEmitter, Output } from "@angular/core";

@Directive()
export abstract class OnBackDirective {
  @Output() onBackClicked = new EventEmitter<void>();

  protected handleBackClick() {
    this.onBackClicked.emit();
  }
}
